
import redPacketAddress from '@/contract/redPacketAddress'
import { ethers } from 'ethers'
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { MetaMask } from './wallet/metaMask'
import { WalletConnect } from './wallet/walletConnect'

type IWalletType = 'Metamask' | 'WalletConnect'

interface IWalletList {
  type: IWalletType
  logo: string
  prompt?: string
  text?: string
}

export default defineComponent({
  emits: ['connect', 'connectError', 'getUserInfo'],

  setup (props, { emit }) {
    const store = useStore()
    const router = useRouter()

    const walletList: IWalletList[] = [
      {
        type: 'Metamask',
        logo: 'metaMask.svg',
        prompt: 'To continue, follow the prompts on your Metamask Wallet.',
        text: ''
      },
      {
        type: 'WalletConnect',
        logo: 'walletConnect.svg',
        prompt: 'To continue, follow the prompts on your WalletConnect.',
        text: 'f(x)Wallet, imToken, Trust, etc.,'
      }
    ]

    let wallet: MetaMask | WalletConnect

    // 获取用户信息
    // async function getUserInfo () {
    //   console.log('getUserInfo', wallet.account)

    //   const address = ethers.utils.getAddress(wallet.account)
    //   const balance = await wallet.getBalance(process.env.VUE_APP_COIN_ADDRESS) as ethers.BigNumber
    //   const chainId = wallet.chainId
    //   const redPackContractAddr = process.env.VUE_APP_CONTRACT

    //   // 保存用户信息
    //   store.commit('SET_USERINFO', {
    //     address,
    //     balance: balance.toString(),
    //     chainId,
    //     redPackContractAddr
    //   })
    // }

    async function toConnect (name: IWalletType) {
      console.log('-------> toConnect <--------')

      if (name === 'Metamask') {
        wallet = new MetaMask()
      } else if (name === 'WalletConnect') {
        wallet = new WalletConnect()
      }

      try {
        await wallet.connect(() => {
          console.log('disconnect')

          store.commit('CLEAR_USERINFO')
          // 保存provider到window，提供全局访问
          window.provider = undefined

          router.push({
            name: 'CreateRedPack'
          })
        })

        console.log(wallet.chainId)

        // 链id错误
        if (wallet.chainId !== Number(process.env.VUE_APP_CHAIN)) {
          emit('connectError', 'To proceed, please select Binance Smart Chain (BSC)')

          return
        }

        // await getUserInfo()

        // console.log('userInfo', userInfo)

        // 保存provider到window，提供全局访问
        window.provider = wallet._provider
        window.wallet = wallet

        emit('connect')
      } catch (error: any) {
        // emit('connectError', error.message)
      }
    }

    return {
      walletList,
      toConnect
    }
  }
})
